<!-- Created by henian.xu on 2020/4/15. -->

<template>
    <div class="experience-list">
        <!--{{ids}}-->
        <template v-if="data && data.length">
            <div
                class="item"
                v-for="item in data"
                :key="item.id"
            >
                <div class="label">{{item.examName}}</div>
                <XIcon
                    content="f012"
                    size="small"
                    theme="g6"
                ></XIcon>
            </div>
        </template>
        <div
            v-else
            class="item noop"
        ><div class="label">暂无数据</div></div>
    </div>
</template>

<script>
export default {
    name: 'Experience',
    data() {
        return {};
    },
    props: {
        ids: {
            type: Array,
            default() {
                return [];
            },
        },
        data: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    watch: {
        ids: {
            async handler(val) {
                const ids = val.join(',');
                if (!val || !val.length || !ids) return;
                const { data } = await this.$api.Sv.ExamPaperExperience.data({ ids }, { isAxiosResponseData: true });
                this.data.splice(0, this.data.length);
                this.data.push(...data);
            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss">
.experience-list {
    background-color: #fff;
    > .item {
        padding: $padding;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        + .item {
            border-top: 1px solid $color-border;
        }

        > .label {
            flex: 1;
        }

        &.noop {
            > .label {
                text-align: center;
                color: $gray6;
            }
        }
    }
}
</style>
